import React from 'react';
import { DeviceConnectionState, UserAction } from '../../../../../data-access/gql-types/graphql';
import { useChannelsStateStore } from '../../../store/channels-state';
import { ChannelType, DashboardUserAction } from '../../../types';
import { Control } from '../base-control';

type ActionControlProps = {
  channels: ChannelType[];
  userAction: DashboardUserAction | UserAction;
  isListItem: boolean;
};

export const ActionControl: React.FC<ActionControlProps> = ({ channels, userAction, isListItem }) => {
  const channelState = useChannelsStateStore((s) => s.channelState);

  if (
    !channels.length ||
    (channels.length &&
      channels.every((channel) => channelState[channel.id]?.deviceConnectionState === DeviceConnectionState.Recovery))
  ) {
    return null;
  }

  return (
    <div className="action-control">
      <Control channels={channels} userAction={userAction} isListItem={isListItem} />
    </div>
  );
};
